import { g as h } from "./_commonjsHelpers-DaMA6jEr.js";
import { d as m, e as F, f as K, g as o, h as J, j as Q, k as X, l as Y, m as Z, n as W, i as j } from "./_baseClone-CPYgn-G_.js";
var z = "__lodash_hash_undefined__";
function V(e) {
  return this.__data__.set(e, z), this;
}
var k = V;
function ee(e) {
  return this.__data__.has(e);
}
var ae = ee, re = m, ne = k, fe = ae;
function $(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new re(); ++a < n; )
    this.add(e[a]);
}
$.prototype.add = $.prototype.push = ne;
$.prototype.has = fe;
var se = $;
function ie(e, a) {
  for (var n = -1, f = e == null ? 0 : e.length; ++n < f; )
    if (a(e[n], n, e))
      return !0;
  return !1;
}
var ue = ie;
function le(e, a) {
  return e.has(a);
}
var te = le, _e = se, ge = ue, ve = te, Ae = 1, de = 2;
function pe(e, a, n, f, u, r) {
  var i = n & Ae, t = e.length, l = a.length;
  if (t != l && !(i && l > t))
    return !1;
  var _ = r.get(e), d = r.get(a);
  if (_ && d)
    return _ == a && d == e;
  var g = -1, s = !0, p = n & de ? new _e() : void 0;
  for (r.set(e, a), r.set(a, e); ++g < t; ) {
    var v = e[g], A = a[g];
    if (f)
      var y = i ? f(A, v, g, a, e, r) : f(v, A, g, e, a, r);
    if (y !== void 0) {
      if (y)
        continue;
      s = !1;
      break;
    }
    if (p) {
      if (!ge(a, function(T, E) {
        if (!ve(p, E) && (v === T || u(v, T, n, f, r)))
          return p.push(E);
      })) {
        s = !1;
        break;
      }
    } else if (!(v === A || u(v, A, n, f, r))) {
      s = !1;
      break;
    }
  }
  return r.delete(e), r.delete(a), s;
}
var N = pe;
function ye(e) {
  var a = -1, n = Array(e.size);
  return e.forEach(function(f, u) {
    n[++a] = [u, f];
  }), n;
}
var Te = ye;
function Ee(e) {
  var a = -1, n = Array(e.size);
  return e.forEach(function(f) {
    n[++a] = f;
  }), n;
}
var Oe = Ee, c = F, R = K, we = o, Pe = N, $e = Te, Le = Oe, Se = 1, qe = 2, ce = "[object Boolean]", Re = "[object Date]", Ce = "[object Error]", De = "[object Map]", Ie = "[object Number]", xe = "[object RegExp]", be = "[object Set]", Me = "[object String]", Be = "[object Symbol]", He = "[object ArrayBuffer]", Ge = "[object DataView]", C = c ? c.prototype : void 0, L = C ? C.valueOf : void 0;
function Ne(e, a, n, f, u, r, i) {
  switch (n) {
    case Ge:
      if (e.byteLength != a.byteLength || e.byteOffset != a.byteOffset)
        return !1;
      e = e.buffer, a = a.buffer;
    case He:
      return !(e.byteLength != a.byteLength || !r(new R(e), new R(a)));
    case ce:
    case Re:
    case Ie:
      return we(+e, +a);
    case Ce:
      return e.name == a.name && e.message == a.message;
    case xe:
    case Me:
      return e == a + "";
    case De:
      var t = $e;
    case be:
      var l = f & Se;
      if (t || (t = Le), e.size != a.size && !l)
        return !1;
      var _ = i.get(e);
      if (_)
        return _ == a;
      f |= qe, i.set(e, a);
      var d = Pe(t(e), t(a), f, u, r, i);
      return i.delete(e), d;
    case Be:
      if (L)
        return L.call(e) == L.call(a);
  }
  return !1;
}
var Ue = Ne, D = J, he = 1, me = Object.prototype, Fe = me.hasOwnProperty;
function Ke(e, a, n, f, u, r) {
  var i = n & he, t = D(e), l = t.length, _ = D(a), d = _.length;
  if (l != d && !i)
    return !1;
  for (var g = l; g--; ) {
    var s = t[g];
    if (!(i ? s in a : Fe.call(a, s)))
      return !1;
  }
  var p = r.get(e), v = r.get(a);
  if (p && v)
    return p == a && v == e;
  var A = !0;
  r.set(e, a), r.set(a, e);
  for (var y = i; ++g < l; ) {
    s = t[g];
    var T = e[s], E = a[s];
    if (f)
      var q = i ? f(E, T, s, a, e, r) : f(T, E, s, e, a, r);
    if (!(q === void 0 ? T === E || u(T, E, n, f, r) : q)) {
      A = !1;
      break;
    }
    y || (y = s == "constructor");
  }
  if (A && !y) {
    var O = e.constructor, w = a.constructor;
    O != w && "constructor" in e && "constructor" in a && !(typeof O == "function" && O instanceof O && typeof w == "function" && w instanceof w) && (A = !1);
  }
  return r.delete(e), r.delete(a), A;
}
var oe = Ke, S = Q, Je = N, Qe = Ue, Xe = oe, I = X, x = W, b = Y, Ye = Z, Ze = 1, M = "[object Arguments]", B = "[object Array]", P = "[object Object]", We = Object.prototype, H = We.hasOwnProperty;
function je(e, a, n, f, u, r) {
  var i = x(e), t = x(a), l = i ? B : I(e), _ = t ? B : I(a);
  l = l == M ? P : l, _ = _ == M ? P : _;
  var d = l == P, g = _ == P, s = l == _;
  if (s && b(e)) {
    if (!b(a))
      return !1;
    i = !0, d = !1;
  }
  if (s && !d)
    return r || (r = new S()), i || Ye(e) ? Je(e, a, n, f, u, r) : Qe(e, a, l, n, f, u, r);
  if (!(n & Ze)) {
    var p = d && H.call(e, "__wrapped__"), v = g && H.call(a, "__wrapped__");
    if (p || v) {
      var A = p ? e.value() : e, y = v ? a.value() : a;
      return r || (r = new S()), u(A, y, n, f, r);
    }
  }
  return s ? (r || (r = new S()), Xe(e, a, n, f, u, r)) : !1;
}
var ze = je, Ve = ze, G = j;
function U(e, a, n, f, u) {
  return e === a ? !0 : e == null || a == null || !G(e) && !G(a) ? e !== e && a !== a : Ve(e, a, n, f, U, u);
}
var ke = U, ea = ke;
function aa(e, a) {
  return ea(e, a);
}
var ra = aa;
const sa = /* @__PURE__ */ h(ra);
export {
  sa as i
};
